import React                       from 'react';
import PropTypes                   from 'prop-types';
import Translations                from '../../../utils/Translations';
import MediaPin                    from '../../Favorite/Actor/MediaPin';
import AlbumDescriptionButtonsItem from './AlbumDescriptionButtonsItem';
import {dislikeMedia, likeMedia}   from '../../ActorMediaVotingActions';
import withGalleryComments         from '../../HigherOrderComponents/ActorProfileVideos/withGalleryComments';
import withGalleryRatings          from '../../HigherOrderComponents/ActorProfileVideos/withGalleryRatings';
import compose                     from '../../HigherOrderComponents/compose';
import AlbumDescriptionLikeButton  from './AlbumDescriptionLikeButton';
import Flux                        from '../../../flux/Flux';


class AlbumDescriptionButtons extends React.Component {
	constructor(props) {
		super(props);

        this.state = {
            album: this.props.album,
        };

		this.onLikeClick     = this.onLikeClick.bind(this);
		this.onDislikeClick  = this.onDislikeClick.bind(this);
		this.onGalleryChange = this.onGalleryChange.bind(this);
	}

    componentDidMount() {
        Flux.Gallery.addGalleryChangeListener(this.onGalleryChange);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.album !== this.props.album) {
            const album = this.props.album;
            album.isBought        = this.state.album.isBought;
            album.isVotingVisible = this.state.album.isVotingVisible;
            this.setState({album});
        }
    }

    componentWillUnmount() {
        Flux.Gallery.removeGalleryChangeListener(this.onGalleryChange);
    }

    onGalleryChange(actorId, albumId) {
		if (albumId === this.state.album.id) {
            const album = Flux.Gallery.getGalleryData(albumId);
            if (!this.state.album.isBought) {
                this.setState({album});
            }
		}
	}

	onLikeClick() {
		likeMedia(this.props.actor.id, this.props.album.id);
	}

	onDislikeClick() {
		dislikeMedia(this.props.actor.id, this.props.album.id);
	}

	render() {
        const {album} = this.state;
		const {actor, baseClassName, showSocialShare}                                                        = this.props;
		const {areCommentsVisible, isVotingVisible, isAllowedToCommentAlbum, guestRatingLikes, guestRatingDislikes} = album;

		return (
			<div className={baseClassName + (!isVotingVisible ? ' jf-right' : '')}>

				{isVotingVisible &&
				<AlbumDescriptionLikeButton baseClassName={baseClassName}
				                             text={album.likes || guestRatingLikes}
				                             checked={album.isLiked}
				                             onClick={this.onLikeClick}
				/>}
				{isVotingVisible &&
				<AlbumDescriptionButtonsItem baseClassName={baseClassName}
				                             icon="-icon-unlike-line"
				                             iconChecked="-icon-unlike-full"
				                             text={album.dislikes || guestRatingDislikes}
				                             tooltipText={Translations.get('DislikeTooltip')}
				                             checked={album.isDisliked}
				                             onClick={this.onDislikeClick}
				                             checkable={false}
				/>}
				{isVotingVisible && (areCommentsVisible || isAllowedToCommentAlbum) && this.props.isCommented &&
				<AlbumDescriptionButtonsItem baseClassName={baseClassName}
				                             icon="-icon-chat-flat-line"
				                             iconChecked="-icon-chat-flat"
				                             text={this.props.commentsTotalCount}
				                             tooltipText={Translations.get('CommentTooltip')}
				                             checked={this.props.isCommented}
				                             onClick={this.props.onCommentsClick}
				                             checkable={false}
				/>}
				<MediaPin actorId={actor.id}
				          albumId={album.id}
				          initialIsFavorite={!!(album.isFavoriteAlbum || album.isFavorite || album.pinned)}
				          fontSize=""
				          tooltipPlacement="top"
				/>
				{showSocialShare &&
				<AlbumDescriptionButtonsItem baseClassName={baseClassName}
				                             icon="-icon-share-icon-line"
				                             iconChecked="-icon-share-icon"
				                             tooltipText={Translations.get('ShareTooltip')}
				                             onClick={this.props.onShareClick}
				/>}
			</div>
		);
	}
}

AlbumDescriptionButtons.propTypes = {
	album:           PropTypes.shape({
		id:                      PropTypes.number,
		description:             PropTypes.string,
		contestPlace:            PropTypes.number,
		releaseDate:             PropTypes.string,
		duration:                PropTypes.string,
		hasAudio:                PropTypes.bool,
		totalViews:              PropTypes.number,
		title:                   PropTypes.string,
		contestDetailsUrl:       PropTypes.string,
		likes:                   PropTypes.number,
		dislikes:                PropTypes.number,
		isLiked:                 PropTypes.bool,
		isDisliked:              PropTypes.bool,
		isFavoriteAlbum:         PropTypes.bool,
		isFavorite:              PropTypes.bool,
		isVotingVisible:         PropTypes.bool,
		areCommentsVisible:      PropTypes.bool,
		isAllowedToCommentAlbum: PropTypes.bool,
		guestRatingLikes:        PropTypes.number,
		guestRatingDislikes:     PropTypes.number,
        pinned:                  PropTypes.bool,
        isBought:                PropTypes.bool,
	}),
	actor:           PropTypes.shape({
		id:   PropTypes.number,
		name: PropTypes.string,
	}),
	baseClassName:   PropTypes.string,
	onShareClick:    PropTypes.func,
	onCommentsClick: PropTypes.func,
	// from withGalleryComments
	commentsTotalCount: PropTypes.number,
	isCommented:        PropTypes.bool,
	showSocialShare:    PropTypes.bool,
};

AlbumDescriptionButtons.defaultProps = {
	baseClassName:   '',
	onShareClick:    () => {
	},
	onCommentsClick: () => {
	},
	showSocialShare: true,
};

export default compose(withGalleryComments, withGalleryRatings)(AlbumDescriptionButtons);
